import { searchParam, useSetSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod/v4';

import AssemblyDashboardPage from '@/areas/assemblies/Assemblies/Dashboard/AssemblyDashboardPage';
import { assemblyTabs } from '@/domain/assembly/assemblyFrontendTypes';
import { assembliesModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/assemblies/$assemblyId/dashboard')({
    staticData: {
        access: { permissions: ['view:assembly'], modulePermissions: assembliesModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    validateSearch: z.object({
        rfqId: z.string().optional(),
        tab: searchParam.enum(assemblyTabs, 'optional'),
        isMonitoringOpen: searchParam.boolean('optional'),
        monitoring: searchParam.boolean('optional'),
    }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const rfqId = Route.useSearch({ select: (search) => search.rfqId });
    const tab = Route.useSearch({ select: (search) => search.tab });
    const isMonitoringOpen = Route.useSearch({ select: (search) => search.isMonitoringOpen });
    const setSearch = useSetSearch();
    return (
        <AssemblyDashboardPage
            {...pathParams}
            rfqId={rfqId}
            tab={tab}
            monitoringDeepLink={{ isOpen: isMonitoringOpen, onSearchChange: setSearch }}
        />
    );
}
